import { render, staticRenderFns } from "./ZaloTodoList.vue?vue&type=template&id=a555d04e&scoped=true"
import script from "./ZaloTodoList.vue?vue&type=script&lang=js"
export * from "./ZaloTodoList.vue?vue&type=script&lang=js"
import style0 from "./ZaloTodoList.vue?vue&type=style&index=0&id=a555d04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a555d04e",
  null
  
)

export default component.exports